import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { LoginUserModel } from '../../../models/loginUserModel';
import { PhotoType } from '../../../models/photoType';
import { DevicesService } from '../../../services/devices.service';
import { Device } from '../../../models/device';
import { jwtDecode } from 'jwt-decode';
import { getObjectDiff } from '../fuel-params-form/fuel-params-form.component';


@Component({
    selector: 'app-photo-params-form',
    imports: [FormsModule, ReactiveFormsModule, ToggleSwitchModule, ButtonModule, DialogModule],
    templateUrl: './photo-params-form.component.html',
    styleUrl: './photo-params-form.component.scss'
})
export class PhotoParamsFormComponent {
  formCard!: FormGroup;
  disabledSwitchPlacas = false;
  get isAdmin() { return this.data.UserType === 'Administrator' || this.data.UserType === 'Modify'; }
  @Input() device!: Device;
  data!: LoginUserModel;
  tokenAuth = "";
  @Output() onSaving: EventEmitter<any> = new EventEmitter<any>();
  @Output() onResponse: EventEmitter<any> = new EventEmitter<any>();
  showMessageError = false;
  messagesError = "";
  allPhotoTypes: PhotoType[] = [];
  selectedPhotoTypes: PhotoType[] = [];
  oldDevice!: Device;
  showConfirm = false;
  messageConfirm = '';
  changes: any = null;
  constructor(private service: DevicesService, private fb: FormBuilder) {

    this.data = JSON.parse(localStorage.getItem('data')!);
  }

  ngOnInit() {

    this.oldDevice = structuredClone(this.device);
    this.loadPhotoTypeList();
    this.disabledSwitchPlacas = this.device.photoTypeList.findIndex((e: any) => e.type_id == 1) > -1;
    this.formCard = this.fb.group({
      fields: new FormArray([])
    });

    this.selectedPhotoTypes = this.device.photoTypeList;



  }

  selectPhotoType(item: PhotoType) {
    let index = this.selectedPhotoTypes.findIndex((e: any) => e.type_id == item.type_id);
    if (index == -1) {
      this.selectedPhotoTypes.push(item);
    } else {
      this.selectedPhotoTypes.splice(index, 1);
    }
  }

  isSelected(item: PhotoType) {
    let index = this.selectedPhotoTypes.findIndex((e: any) => e.type_id == item.type_id);
    return index > -1
  }

  isPlatesSelected() {

    let index = this.selectedPhotoTypes.findIndex((e: any) => e.description.trim() == 'Placas');
    return index > -1
  }

  get plates() {
    return this.formCard.get('plates') as FormControl;
  }

  get odometer() {
    return this.formCard.get('odometer') as FormControl;
  }
  get license() {
    return this.formCard.get('license') as FormControl;
  }
  get ecoNumber() {
    return this.formCard.get('ecoNumber') as FormControl;
  }

  get operator() {
    return this.formCard.get('operator') as FormControl;
  }

  isInCard(photoType: any) {

    return this.device.photoTypeList.findIndex((e: any) => e.type_id == photoType.type_id) > -1
  }

  disableSwitch(item: PhotoType) {
    let isPlatesChecked = this.device.photoTypeList.findIndex((e: any) => e.type_id == 1) > -1;

    if (this.data.UserType == 'Administrator' || this.data.UserType == 'Modify') {
      if (isPlatesChecked) {
        let itemFounded = this.device.photoTypeList.at(this.device.photoTypeList.findIndex((e: any) => e.type_id == 1))
        return itemFounded!.type_id == item.type_id;
      } else {
        return false;
      }
    } else {
      return true;
    }


  }

  updatePhoto() {

  }

  getItem(key: string) {
    return this.allPhotoTypes.find((e: any) => e.key == key)!;
  }

  showConfirmDialog() {
    let allPhotos: PhotoType[] = [];

    this.allPhotoTypes.forEach(element => {
      if (this.isSelected(element)) {
        element.active = 1
      } else {
        element.active = 0
      }
      allPhotos.push(element);
    });



    this.device.photoTypeList = allPhotos;
    const fields = ["photoTypeList"];
    this.changes = '';
    if (this.oldDevice.photoTypeList.length > 0) {
      this.device.photoTypeList.forEach(element => {
        let find = this.oldDevice.photoTypeList.find((pto: PhotoType) => pto.type_id == element.type_id);
        if (find) {
          if (find!.active != element.active) {
            if (find?.active == 1) {
              this.changes += `El campo ${element.description} se desactivó<br>`
            } else {
              this.changes += `El campo ${element.description} se activó<br>`
            }
          }
        } else {
          if(element.active==1)
              this.changes += `El campo ${element.description} se activó<br>`
        }

      });
    } else {
      allPhotos.forEach(element => {
        if (element.active == 1) {
          this.changes += `El campo ${element.description} se activó<br>`
        }
      });
    }



    if (this.changes != '') {
      this.messageConfirm = `Se guardarán los siguientes cambios:<span class='text-sm'><br>${this.changes}</span><br><b> ¿Desea continuar?</b>`;
      this.showConfirm = true;
    }

  }

  savePhotos() {
    let items: any[] = [];
    if (!this.isPlatesSelected()) {
      this.messagesError = "El campo de placas es requerido";
      this.showMessageError = true;
    } else {

      this.onSaving.emit(true);
      this.service.saveCardParams(this.device, this.data.Client_number, this.data.User_id, "FotoCargas", this.data.UserType == 'Administrator' ? 'Administrador de la cuenta' : this.data.Name).subscribe({
        next: (resp: any) => {
          this.onSaving.emit(false);
          resp.isSave = true;
          if (resp.errorCode == 1) {
            this.showMessageError = true;
            this.messagesError = resp.errorDesc;

          } else {
            resp.isSave = true;
            this.onResponse.emit(resp);

          }
        },
        error: (err: any) => {

          this.onSaving.emit(false);
          let resp = {
            errorDesc: err,
            errorCode: 1

          }
          this.onResponse.emit(resp);
        }
      });


    }
  }



  loadPhotoTypeList() {
    this.service.getPhotoTypeList().subscribe({
      next: (resp: any) => {
        this.allPhotoTypes = resp;
        this.selectedPhotoTypes
        this.allPhotoTypes.forEach(element => {
          let founded = this.selectedPhotoTypes.findIndex((pt: PhotoType) => pt.type_id == element.type_id);
          if (founded > -1) {
            this.selectedPhotoTypes.at(founded)!.description = element.description;
          }
        });
      },
      error: (err: any) => {
        this.allPhotoTypes = [];
      }
    })


  }


}
